export default "__VITE_ASSET__Z7g0jVkf__"